import { translateOrderTypeItemName } from "../../../common/enums/orderTypes.enum";

export const DetailedPriceListColumns = (t: any) => [
    {
      key: "companyName",
      name: t("pricing.columns.companyName"),
      fieldName: "companyName",
      minWidth: 160,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "receptionPlaceAddress",
      name: t("pricing.columns.receptionPlaceAddress"),
      fieldName: "receptionPlaceAddress",
      minWidth: 160,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "orderTypeItem",
      name: t("pricing.columns.orderTypeItem"),
      fieldName: "orderTypeItem",
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: any) => {
        const map: Record<string, string> = {
          "Osobowe":                   t("orders.tireTypes.personal"),
          "Ciężarowe":                 t("orders.tireTypes.truck"),
          "Motocyklowe":               t("orders.tireTypes.motorcycle"),
          "Wolnobieżna":               t("orders.tireTypes.slowMoving"),
          "Wolnobieżne":               t("orders.tireTypes.slowMoving"),
          "Specjalne - pełne":         t("orders.tireTypes.specialSolid"),
          "Specjalne - pneumatyczne":  t("orders.tireTypes.specialPneumatic"),
        };
        return item.orderTypeItem in map ? map[item.orderTypeItem] : translateOrderTypeItemName(item.orderTypeItem, t);
      },
    },
    {
      key: "currentPrice",
      name: t("pricing.columns.currentPrice"),
      fieldName: "currentPrice",
      minWidth: 80,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "companySpecialPrice",
      name: t("pricing.columns.companySpecialPrice"),
      fieldName: "companySpecialPrice",
      minWidth: 80,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "companySpecialPriceTo",
      name: t("pricing.columns.companySpecialPriceTo"),
      fieldName: "companySpecialPriceTo",
      minWidth: 70,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "receptionPlaceSpecialPrice",
      name: t("pricing.columns.receptionPlaceSpecialPrice"),
      fieldName: "receptionPlaceSpecialPrice",
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "receptionPlaceSpecialPriceTo",
      name: t("pricing.columns.receptionPlaceSpecialPriceTo"),
      fieldName: "receptionPlaceSpecialPriceTo",
      minWidth: 70,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "unitPrice",
      name: t("pricing.columns.unitPrice"),
      fieldName: "unitPrice",
      minWidth: 120,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "postalCodePrice",
      name: t("pricing.columns.postalCodePrice"),
      fieldName: "postalCodePrice",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
  ];